(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    (() => {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const videos = new Map();
  let timer;

  const update = () => {
    videos.forEach((video, container) => {
      if (!container.isConnected) {
        video.pause();
        videos.delete(container);
        return;
      }

      const rect = container.getBoundingClientRect();
      const gallery = container.closest('.product__media-list');
      const bounds = gallery.getBoundingClientRect();

      const width = Math.max(
        0,
        Math.min(rect.right, bounds.right, window.innerWidth) -
        Math.max(rect.left, bounds.left, 0)
      );

      const visible =
        !document.hidden &&
        rect.width > 0 &&
        width / rect.width > 0.5 &&
        rect.bottom > 0 &&
        rect.top < window.innerHeight;

      if (visible && !reducedMotion.matches) {
        video.muted = true;

        if (video.paused) {
          video.play().catch(() => {});
        }
      } else {
        video.pause();
      }
    });
  };

  const observer = new IntersectionObserver(update, {
    threshold: [0, 0.25, 0.5, 0.75, 1]
  });

  const init = () => {
    document.querySelectorAll(
      '.product__media-list .media-type-video'
    ).forEach((container) => {
      if (videos.has(container)) return;

      const host = container.querySelector('deferred-media');
      const source = host?.querySelector('template')
        ?.content.querySelector('video');

      if (!host || !source) return;

      let video = host.querySelector('video');
      const existing = Boolean(video);

      if (!video) {
        video = source.cloneNode(true);
      }

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';

      video.removeAttribute('controls');
      video.removeAttribute('autoplay');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');

      if (!existing) {
        host.appendChild(video);
      }

      host.setAttribute('loaded', 'true');
      container.classList.add('kg-autoplay');

      videos.set(container, video);
      observer.observe(container);

      if (!existing) {
        video.load();
      }
    });

    update();
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(update, 80);
  };

  document.addEventListener('scroll', schedule, {
    capture: true,
    passive: true
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('media-gallery')) {
      schedule();
    }
  });

  document.addEventListener('visibilitychange', update);
  window.addEventListener('resize', schedule);
  reducedMotion.addEventListener('change', update);
  document.addEventListener('shopify:section:load', init);

  const start = () => {
    init();

    new MutationObserver(init).observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
